module.exports = __webpack_public_path__ + "media/images/emblems/Obergoesgen-blason-fab7f166730abe63355a3e5b8b1ef164.png";